import { LayersIcon, ResetPasswordIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Form } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
	Field,
	FieldDescription,
	FieldGroup,
	FieldLabel,
} from "@/components/ui/field";
import { GridPattern } from "@/components/ui/grid-pattern";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface Props {
	sid: string;
	errors?: Record<string, string[]>;
}

export default function Edit({ sid, errors }: Props) {
	return (
		<div className="grid min-h-svh lg:grid-cols-2">
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div className="flex justify-center gap-2 md:justify-start">
					<a href="/" className="flex items-center gap-2 font-medium">
						<div className="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
							<HugeiconsIcon
								icon={LayersIcon}
								strokeWidth={2}
								className="size-4"
							/>
						</div>
						AML Management
					</a>
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-sm">
						<Form
							action={`/identity/password_reset?sid=${sid}`}
							method="patch"
							disableWhileProcessing
							className="flex flex-col gap-6"
						>
							<FieldGroup>
								<div className="flex flex-col items-center gap-1 text-center">
									<div className="mb-2 flex size-12 items-center justify-center rounded-lg bg-primary/10">
										<HugeiconsIcon
											icon={ResetPasswordIcon}
											strokeWidth={2}
											className="size-6 text-primary"
										/>
									</div>
									<h1 className="font-bold text-2xl">Nové heslo</h1>
									<p className="text-balance text-muted-foreground text-sm">
										Zadejte své nové heslo
									</p>
								</div>

								<Field>
									<FieldLabel htmlFor="password">Nové heslo</FieldLabel>
									<Input
										id="password"
										name="password"
										type="password"
										aria-invalid={!!errors?.password}
										required
										autoComplete="new-password"
									/>
									{errors?.password && (
										<FieldDescription className="text-destructive">
											{errors.password.join(", ")}
										</FieldDescription>
									)}
								</Field>

								<Field>
									<FieldLabel htmlFor="password_confirmation">
										Potvrzení hesla
									</FieldLabel>
									<Input
										id="password_confirmation"
										name="password_confirmation"
										type="password"
										aria-invalid={!!errors?.password_confirmation}
										required
										autoComplete="new-password"
									/>
									{errors?.password_confirmation && (
										<FieldDescription className="text-destructive">
											{errors.password_confirmation.join(", ")}
										</FieldDescription>
									)}
								</Field>

								<Field>
									<Button type="submit" className="w-full">
										Nastavit nové heslo
									</Button>
								</Field>

								<Field>
									<FieldDescription className="text-center">
										<a href="/sign_in" className="underline underline-offset-4">
											Zpět na přihlášení
										</a>
									</FieldDescription>
								</Field>
							</FieldGroup>
						</Form>
					</div>
				</div>
			</div>
			<div className="relative hidden overflow-hidden bg-muted lg:block">
				<GridPattern
					squares={[
						[0, 1],
						[1, 3],
						[2, 2],
						[3, 4],
						[4, 0],
						[5, 2],
						[6, 4],
						[7, 1],
						[8, 3],
						[9, 5],
					]}
					className={cn(
						"mask-[radial-gradient(500px_circle_at_center,white,transparent)]",
						"inset-x-0 inset-y-[-30%] h-[160%] skew-y-12",
					)}
				/>
			</div>
		</div>
	);
}
